import type { DataExplorerViewShellProps } from './types';
import { cn } from './utils';

export function DataExplorerViewShell({
  header,
  footer,
  overlay,
  empty,
  isEmpty = false,
  children,
  className,
  classNames,
}: DataExplorerViewShellProps) {
  return (
    <section
      className={cn(
        'relative flex min-h-0 flex-1 flex-col overflow-hidden',
        classNames?.root,
        className,
      )}
    >
      {header ? (
        <div className={cn('shrink-0', classNames?.header)}>{header}</div>
      ) : null}

      <div
        className={cn(
          'flex min-h-0 flex-1 flex-col overflow-hidden',
          classNames?.body,
        )}
      >
        {isEmpty && empty ? (
          <div
            className={cn(
              'flex h-full items-center justify-center p-6 text-sm text-muted-foreground',
              classNames?.empty,
            )}
          >
            {empty}
          </div>
        ) : (
          children
        )}
      </div>

      {footer ? (
        <div className={cn('shrink-0', classNames?.footer)}>{footer}</div>
      ) : null}

      {overlay ? (
        <div className={cn('absolute inset-0', classNames?.overlay)}>{overlay}</div>
      ) : null}
    </section>
  );
}
